<template>
  <div>
    <v-form>
      <v-card color="grey lighten-5">
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title class="baslikfont">Şirket Parametreleri</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn hidden="xs" flat @click="Kaydet()"> Kaydet
                <v-icon right dark>add_box</v-icon>
              </v-btn>
            </v-toolbar>
          </v-flex>
          <v-tabs style="width:100%; height:100%" dark="" v-model="active" color="blue darken-3" slot="extension"
            slider->
            <v-tabs-slider></v-tabs-slider>
            <v-tab href='#0'>
              Genel
            </v-tab>
            <v-tab-item :id="'0'" style="width:100%; height:100%;">
              <v-layout row="" wrap="">
                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>


                          <v-text-field hide-details="" v-model="SirketParametre.Il" label="İl"></v-text-field>
                          <v-text-field label="İlçe" hide-details="" v-model="SirketParametre.Ilce"></v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Tel" label="Tel">
                          </v-text-field>
                          <v-text-field mask="NNNNNNNNNNNNNNN" hide-details="" v-model="SirketParametre.Fax" label="Fax">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.Email" label="Firma E-mail Adresi">
                          </v-text-field>
                          <v-textarea v-model="SirketParametre.Adres" hide-details label="Adres"></v-textarea>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>


                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>

                        <v-layout justify-space-between column>

                          <v-text-field hide-details="" v-model="SirketParametre.VergiDairesi" label="Vergi Dairesi"></v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.VergiNo" label="Vergi Numarası"></v-text-field>
                          <v-text-field hide-details="" type="Number" v-model="SirketParametre.FaturaSatirAdedi" label="Fatura Satır Adet"
                            value=""></v-text-field>
                          <v-text-field hide-details="" label="Ticaret Sicil No" v-model="SirketParametre.TicaretSicilNo"
                            value=""></v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.KasaDevir" label="Kasa Devir">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.MersisNo" label="Mersis No">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.WebAdres" label="Firma Web Adresi">
                          </v-text-field>
                        </v-layout>

                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

                <v-flex pa-1 xs12 sm12 md4>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-layout justify-space-between column>

                          <v-text-field hide-details="" v-model="SirketParametre.SmsKod" label="SMS Müşteri Kodu">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.SmsSifre" label="SMS Şifre">
                          </v-text-field>
                          <v-text-field hide-details="" v-model="SirketParametre.SerbestMail" label="Serbest Fatura Mail Dizayn">
                          </v-text-field>
                          <v-select :items="doviztipi" clearable item-text="DovizAdi" item-value="DovizKod" v-model="SirketParametre.DefaultCurrency"
                            label="Varsayılan Para Birimi"></v-select>
                          <v-select :items="efaturatipi" hide-details="" item-text="text" item-value="value" v-model="SirketParametre.VarsayilanEfaturaTip"
                            label="E-Fatura Tipi" clearable=""></v-select>
                          <v-select :items="kurparametresi" clearable hide-details="" v-model="SirketParametre.OpsiyonBilgileri.KurParametre"
                            item-text="text" item-value="value" label="Kur Parametresi" autocomplete></v-select>
                        </v-layout>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-tab-item>

            <v-tab href='#1' ripple>
              Opsİyon
            </v-tab>
            <v-tab-item :id="'1'">
              <v-container fluid="">
                <v-layout row="" wrap="">

                  <v-flex xs12 sm6 md4>
                    <v-switch label="Bilet Paketi Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.BiletPaket"
                      value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Muhasebe 5a Kullanıyor" v-model="SirketParametre.MuhasebeBilgileri.Muh5aEnt" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Coper Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.CoperKullan" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Fatura Kapama Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.FaturaKapama"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Müşteri Personel Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.MusteriPersonel"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Yolcu CRM Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.YolcuCrm" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Fatura Mail Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.FaturaMail"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Profil Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.Profil" value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="E-Defter Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.EDefter" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="E-Arşiv Kullanıyor" v-model="SirketParametre.OpsiyonBilgileri.EArsiv" value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="İskonto Basılsın" v-model="SirketParametre.OpsiyonBilgileri.IskontoBas" value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Müşteride Risk Göster" v-model="SirketParametre.OpsiyonBilgileri.Risk" value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Satış Döviz KDV'siz Tutardan" v-model="SirketParametre.OpsiyonBilgileri.KdvsizSatis"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Alış Döviz KDV'siz Tutardan" v-model="SirketParametre.OpsiyonBilgileri.KdvsizAlis"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Satış No'su Bilet İle Senkronize Olsun" v-model="SirketParametre.OpsiyonBilgileri.FaturaNoSenkronize"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Fatura Mail İçin Outlook Kullan" v-model="SirketParametre.OpsiyonBilgileri.MailOutlook"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Otomatik E-Fatura No Ver" v-model="SirketParametre.OpsiyonBilgileri.OtomatikEFaturaNo"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="E-Fatura Sıfır Serili" v-model="SirketParametre.OpsiyonBilgileri.EFaturaSifirSerili"
                      c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Standart E-Fatura Sistemi" v-model="SirketParametre.OpsiyonBilgileri.EFaturaKullaniyor"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Özel E-Fatura Sistemi" v-model="SirketParametre.OpsiyonBilgileri.OzelFaturaKullaniyor"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Yeni Versiyonu Kontrol Etme" v-model="SirketParametre.OpsiyonBilgileri.YeniVersiyonKontrol"
                      value="1"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="E-Fatura ve E-Arşiv Detay Bas" value="1" c></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Faturada Adresin 2. Satırını Adres2'den Al" value="1" v-model="SirketParametre.Adres2"></v-switch>
                  </v-flex>
                  <v-flex xs12 sm6 md4>
                    <v-switch label="Entegrasyon İptalinde Mahsup İptal Olsun" v-model="SirketParametre.OpsiyonBilgileri.EntMahsup"
                      value="1" c></v-switch>
                  </v-flex>


                </v-layout>
              </v-container>
            </v-tab-item>


            <v-tab href='#2' ripple>
              Çek Senet
            </v-tab>
            <v-tab-item :id="'2'" style="width:100%; height:100%;">
              <v-flex pa-1 xs12 sm12 md4>
                <v-card>
                  <v-card color="grey lighten-5" flat="">
                    <v-card-actions>
                      <v-layout row="" wrap="">

                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekAlindiBno"
                              label="Alınan Çekler Muh. No">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetAlindiBNo"
                              label="Alınan Senetler Muh. No">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.CekTevdiBno" label="Verilen Firma Çek Muh. No">
                            </v-text-field>
                            <v-text-field hide-details="" v-model="SirketParametre.CekSenetBilgileri.SenetVHesap" label="Verilen Firma Çek Muh. No">
                            </v-text-field>
                          </v-layout>
                        </v-flex>


                      </v-layout>
                    </v-card-actions>
                  </v-card>
                </v-card>
              </v-flex>
            </v-tab-item>

            <v-tab href='#3' ripple>
              Muhasebe
            </v-tab>
            <v-tab-item :id="'3'">
              <v-layout row wrap>
                <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                        <v-flex xs12 sm12 md12>
                          <v-layout justify-space-between column>

                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Tanımlamalar</span>
                          </v-card-title>
                        </v-card>

                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisKHesap" hide-details="" label="Alınan İskonto">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.VerisVHesap" hide-details="" label="Verilen İskonto">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuhasebeSirket" hide-details=""
                              label="Muhasebe Şirketi">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.KasaHesap" hide-details="" label="Kasa Muhasebe No">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisFaturaKdvHesap" hide-details=""
                              label="Satış Fat.Hes.KDV Muh.No">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisFaturaKdvHesap" hide-details=""
                              label="Alış Fat. İnd. KDV Muh. No">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.SatisIadeKdvHesap" hide-details=""
                              label="Satış İade KDV Muh. Kodu">
                            </v-text-field>
                            <v-text-field v-model="SirketParametre.MuhasebeBilgileri.AlisIadeKdvHesap" hide-details=""
                              label="Alış İade KDV Muh. Kodu ">
                            </v-text-field>
                          </v-layout>
                        </v-flex>
                      </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

  <v-flex pa-1 xs12 sm6 md6>
                  <v-card>
                    <v-card color="grey lighten-5" flat="">
                      <v-card-actions>
                  <v-layout justify-space-between column>

                        <v-card flat="" color="#9E9E9E">
                          <v-card-title>
                            <span class="subheading white--text font-weight-medium "> Muhasebe Kırılımları</span>
                          </v-card-title>
                        </v-card>

                    <v-layout>

                      <v-text-field v-model="SirketParametre.MuhasebeBilgileri.GrupKirilim" hide-details="" label="Grup"></v-text-field>
                      <v-text-field v-model="SirketParametre.MuhasebeBilgileri.MuavinKirilim" hide-details="" label="Muavin">
                      </v-text-field>
                    </v-layout>
                  </v-layout>


                 </v-card-actions>
                    </v-card>
                  </v-card>
                </v-flex>

              </v-layout>
            </v-tab-item>
          </v-tabs>


        </v-layout>
      </v-card>
    </v-form>
    <template>
      <v-card>
        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'"
          :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
        </v-snackbar>
      </v-card>
    </template>
  </div>
</template>

<script>
  import auth from '../../../api/auth'

  export default {
    data() {
      return {
        date: null,
        dateFormatted: null,
        menu: false,
        drawer: null,
        baslik: '',
        SirketParametre: {
          SirketKodu: '1',
          Adres: '',
          Adres2: '',
          VergiDairesi: '',
          VergiNo: '',
          FaturaSatirAdedi: '',
          KasaDevir: '',
          KapatTarihi: '',
          KapatSifre: '',
          SmsSifre: '',
          SmsKod: '',
          Tel: '',
          Fax: '',
          Email: '',
          Ilce: '',
          Il: '',
          PostaKodu: '',
          CoperSirket: '',
          TicaretSicilNo: '',
          WebAdres: '',
          VarsayilanEfaturaTip: '',
          Dil: '',
          DefaultCurrency: '',
          MersisNo: '',
          SerbestMail: '',
          CekSenetBilgileri: {
            CekPHesap: '',
            CekPKebir: '',
            CekPGrup: '',
            CekPMuavin: '',
            SenetPHesap: '',
            SenetPKebir: '',
            SenetPGrup: '',
            SenetPMuavin: '',
            CekAlindiBno: '',
            CekTevdiBno: '',
            CekNo: '',
            SenetAlindiBNo: '',
            SenetTevdiBNo: '',
            SenetNo: '',
            CekVHesap: '',
            CekVKebir: '',
            CekVGrup: '',
            CekVMuavin: '',
            SenetVHesap: '',
            SenetVKebir: '',
            SenetVGrup: '',
            SenetVMuavin: '',
          },
          MuhasebeBilgileri: {
            Muh5aEnt: '',
            GrupKirilim: '',
            MuavinKirilim: '',
            MuhasebeSirket: '',
            KasaHesap: '',
            KasaKebir: '',
            KasaGrup: '',
            KAsaMuavin: '',
            SatisFaturaKdvHesap: '',
            AlisFaturaKdvHesap: '',
            SatisIadeKdvHesap: '',
            AlisIadeKdvHesap: '',
            AlisKHesap: '',
            VerisVHesap: '',
          },
          OpsiyonBilgileri: {
            IskontoBas: '',
            BiletPaket: '',
            Risk: '',
            KdvsizSatis: '',
            KdvsizAlis: '',
            FaturaNoSenkronize: '',
            CoperKullan: '',
            FaturaKapama: '',
            MusteriPersonel: '',
            YolcuCrm: '',
            FaturaMail: '',
            MailOutlook: '',
            Profil: '',
            YeniVersiyonKontrol: '',
            EFaturaKullaniyor: '',
            OzelFaturaKullaniyor: '',
            OtomatikEFaturaNo: '',
            KurParametre: '',
            EntParam: '',
            EntMahsup: '',
            EDefter: '',
            EArsiv: '',
            EFaturaSifirSerili: ''
          }
        },

        efaturatipi: [{
            text: 'Ticari',
            value: '0'
          },
          {
            text: 'Temel',
            value: '1'
          },
          {
            text: 'İhracat',
            value: '2'
          }
        ],

        kurparametresi: [{
            text: 'Alış',
            value: '0'
          },
          {
            text: 'Satış',
            value: '1'
          },
          {
            text: 'Efektif Alış',
            value: '2'
          },
          {
            text: 'Efektif Satış',
            value: '3'
          }

        ],
        doviztipi: [],

        GenelParametre: {
          KdvOran: '',
          HavaYoluHesapGrubu: '',
          SerbestFatura: '',
          SonDekontNo: '',
          DekontTek: '',
          TumSirketler: '',
          XmlPath: '',
          AktarimSure: '',
          XmlPathCari: '',
          XmlPathMaliyetFaturasi: '',
          XmlPathCariHareket: '',
          TumSirketSecili: '',
          FaturaEn: '',
          FaturaBoy: '',
          OzelBoy: '',
          Dot9Sifre: '',
          BolgeAyar: '',
          AnaEkran: '',
          CariAra: '',
          MasrafZorunlu: '',
          MerkezKur: '',
          SerbestFaturaDoviz: '',
          FaturaKapamaAktif: '',
          FaturaKapamaTarih: '',
          CariAramaIc: '',
          DisAkatarimZorunlu: ''
        },
        text1: '',
        active: '',
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000
      }
    },
    beforeMount: beforeMount,

    methods: {
      Kaydet: Kaydet
    },
  }

  function Kaydet() {

    var params = this.SirketParametre
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyAdd', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.text1 = response.body.ResponseMessage
      this.snackbar = true

    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }



  function beforeMount() {
    this.$http.post(auth.API_URL + 'api/currency/List', {}, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        console.log('ea')
      } else {
        console.log('ea')
      }
    })

    var params = {
      SirketKodu: this.SirketParametre.SirketKodu
    }
    this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.SirketParametre = response.body
      this.SirketParametre.VarsayilanEfaturaTip = String(response.body.VarsayilanEfaturaTip)
      this.SirketParametre.OpsiyonBilgileri.KurParametre = String(response.body.OpsiyonBilgileri.KurParametre)
    }, (response) => {
      if (response.status === 0) {
        this.text = 'Service Unavailable'
        this.snackbar = true

      } else {
        this.text = 'Service Unavailable'
        this.snackbar = true
      }
    })
  }
</script>
<style>
</style>